// Pure helpers for /ask (questions across all of a user's videos, answered by askLibrary).
export const FREE_LIBRARY_QUESTIONS = 5;   // per calendar month (UTC); mirrors library_context.py
export const PRO_LIBRARY_QUESTIONS = 100;

export const libraryLimit = plan => ((plan?.currentPlan || '').toLowerCase() === 'pro' ? PRO_LIBRARY_QUESTIONS : FREE_LIBRARY_QUESTIONS);

export const currentMonth = (now = new Date()) => now.toISOString().slice(0, 7);

export const questionsUsed = (chat, month = currentMonth()) => (chat && chat.month === month ? chat.used || 0 : 0);

export function turnsOf(chat) {
  return Object.entries(chat?.turns || {})
    .map(([id, t]) => ({ id, ...t }))
    .sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0));
}

const toSeconds = stamp => stamp.split(':').reduce((acc, p) => acc * 60 + Number(p), 0);

// "[2 · 4:15]" / "[2]" citations → Markdown links to that source's workspace (handled by the page's link
// renderer). Unknown source numbers stay as plain text.
export function linkCitations(answer, sources) {
  const byN = new Map((sources || []).map(s => [String(s.n), s]));
  return (answer || '').replace(/\[(\d{1,2})(?:\s*[·•-]\s*(\d{1,2}(?::\d{2}){1,2})(?:\s*[–—-]\s*\d{1,2}(?::\d{2}){1,2})?)?\]/g, (match, n, stamp) => {
    const src = byN.get(n);
    if (!src) return match;
    const id = src.content_id.replace(/^workspace-/, '');
    const label = stamp ? `${n} · ${stamp}` : n;
    return `[${label}](/workspace/${id}${stamp ? `?t=${toSeconds(stamp)}` : ''} "${src.title.replace(/"/g, "'")}")`;
  });
}

// A pending question whose request died (askLibrary times out at 300 s) shows as failed and no longer
// blocks the box. Optimistic turns (not yet on the server) have no created_at and count as fresh.
export const STALE_PENDING_MS = 6 * 60 * 1000;
const millis = ts => (ts && typeof ts.toMillis === 'function' ? ts.toMillis() : null);

export function withStale(turns, now = Date.now()) {
  return turns.map(t => {
    const created = millis(t.created_at);
    return t.status === 'pending' && created != null && now - created > STALE_PENDING_MS
      ? { ...t, status: 'error', answer: 'Sorry, I couldn’t answer that one. This question wasn’t counted. Please try again.' }
      : t;
  });
}
